import {
  FETCH_INVESTORS,
  FetchInvestorsAction,
  RESET_DATA_INVESTORS,
  UPDATE_INVESTORS,
  SELECTED_LINKED_ACCOUNT,
  selectedLinkedAccountAction
} from '../../actions/investor/fetchInvestors';
import { IInvestorsReport, Investor } from '../../../types/investorTypes';
import { PaginationInfo } from '../../../types/sharedTypes';
import {
  FetchInvestorsReportAction,
  FETCH_INVESTORS_REPORT
} from '../../../components/administrator/investorsReport/fetchInvestorsReport';
// TODO delete a field isSelected
export interface InvestorsState {
  investors: Array<Investor>;
  investorsReport: Array<IInvestorsReport>;
  paginationInfo: PaginationInfo;
  isSelected: boolean;
}

const initialState: InvestorsState = {
  investors: [],
  investorsReport: [],
  paginationInfo: new PaginationInfo(),
  isSelected: false
};

const investorsReducer = (
  state: InvestorsState = initialState,
  action: FetchInvestorsAction & selectedLinkedAccountAction & FetchInvestorsReportAction
): InvestorsState => {
  switch (action.type) {
    case FETCH_INVESTORS:
      return {
        ...state,
        investors: action.investors,
        paginationInfo: action.paginationInfo
      };
    case RESET_DATA_INVESTORS:
      return {
        ...state,
        investors: [],
        paginationInfo: new PaginationInfo(),
        isSelected: false
      };
    case UPDATE_INVESTORS:
      return {
        ...state,
        investors: [...action.investors]
      };
    case SELECTED_LINKED_ACCOUNT:
      return {
        ...state,
        isSelected: action.isSelected
      };
    case FETCH_INVESTORS_REPORT:
      return {
        ...state,
        investorsReport: action.investorsReport,
        paginationInfo: action.paginationInfo
      };

    // case INVESTORS_SORT_BY_EQUITY_UP:
    //   return {
    //     ...state,
    //     investors: state.investors.sort((a, b) => )
    //   }

    default:
      return state;
  }
};

export default investorsReducer;
